import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { DataService } from '../services/data.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent {
  url: string = 'users';
  id!: string;
  form!: FormGroup;
  roles: Array<any> = [];
  step = 1;
  showPassword = false;
  showPasswordTwo = false;

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      temporaryPassword: [''],
      newPassword: [''],
      confirmNewPassword: [''],
    });
  }

  ngOnInit(): void {}

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.step == 1) {
      this.verifyEmail();
    } else {
      this.verifyTemporaryPass();
    }
  }

  verifyEmail(): void {
    const formData = {
      ...this.form.value,
    };

    console.log('form value', this.form.value);

    this.dataService
      .postData(`${this.url}/verifyEmail`, formData)
      .subscribe((response) => {
        console.log('response email', response);
        if (response.rst) {
          this.step = 2;
          this.id = response.id;
          this.setValidator();
          //this.router.navigateByUrl('/numbers/accounting');
        } else {
          this.messageService.add('The verification email is wrong!', 'secondary');
        }
      });
  }

  verifyTemporaryPass(): void {
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .postData(`${this.url}/verifyTemporaryPass/${this.id}`, formData)
      .subscribe((response) => {
        console.log('response', response);
        if (response.rst) {
          this.form.reset();
          this.clearValidator();
          this.router.navigateByUrl('/pages/login');
        } else {
          this.messageService.add(
            'The verification temporary password is wrong!',
            'secondary'
          );
        }
      });
  }

  setValidator() {
    this.updateControlValidators('temporaryPassword', [Validators.required]);
    this.updateControlValidators('newPassword', [Validators.required]);
    this.updateControlValidators('confirmNewPassword', [Validators.required]);
  }

  clearValidator() {
    this.updateControlValidators('temporaryPassword', null);
    this.updateControlValidators('newPassword', null);
    this.updateControlValidators('confirmNewPassword', null);
  }

  private updateControlValidators(
    controlName: string,
    validators: ValidatorFn[] | null
  ) {
    const control = this.form.get(controlName);
    if (control) {
      control.setValidators(validators);
      control.updateValueAndValidity();
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordVisibilityTwo() {
    this.showPasswordTwo = !this.showPasswordTwo;
  }
}
